<header>
	<nav class="navbar is-light">
		<div class="container">
			<div class="navbar-brand">
				<img class="logo" src="/assets/images/logo.png" alt="Free Rate Update">
			</div>

			<div class="navbar-end" *ngIf="officeStatus && officeStatus.answer">
				<p class="has-text-grey-dark is-size-6-mobile">or call for rates...</p>
				<p class="is-size-4 is-size-5-mobile">
					<a href="tel:{{officeStatus.phone}}" target="_blank">
						<i class="fas fa-phone"></i>
						{{ officeStatus.phonefancy }}
					</a>
				</p>
			</div>
		</div>
	</nav>
</header>

<section class="section" id="premium-questions">
	<div class="container">
		<h1 *ngIf="! premiumQuestions" class="title is-size-4 has-text-centered has-text-black">
			<i class="fas fa-spinner fa-pulse fa-fw"></i>
			Loading your information...
		</h1>

		<h1 *ngIf="premiumQuestions" class="title is-size-4 has-text-centered has-text-black">
			Please verify the following questions to send your information to our premium lenders. Thank you!
		</h1>

		<premium-lead-form *ngIf="premiumQuestions" [premiumQuestions]="premiumQuestions" [leadId]="leadId">
			Loading your information...
		</premium-lead-form>

		<article class="message is-danger" *ngIf="showError">
			<div class="message-header">
				<p>Error</p>
				<button class="delete" aria-label="delete"></button>
			</div>

			<div class="message-body">
				{{ errorMessage || 'Unable to load content, please try again later.' }}
			</div>
		</article>
	</div>
</section>

<footer class="footer has-text-grey">
	<div class="container">
		<div class="columns">
			<div class="column">
				<img class="logo" src="/assets/images/logo.png" alt="Free Rate Update">
			</div>

			<div class="column">
				<p class="is-size-4 is-size-5-mobile" *ngIf="officeStatus && officeStatus.answer">
					<a class="has-text-grey" href="tel:{{ officeStatus.phone }}" target="_blank">
						<span class="icon">
							<i class="fas fa-phone"></i>
						</span>
						{{ officeStatus.phonefancy }}
					</a>
				</p>
				<p>
					<span class="icon is-pulled-left">
						<i class="fas fa-map-marker is-size-4 is-size-5-mobile"></i>
					</span>
					2 Ponds Edge Drive
					<br>Chadds Ford, PA 19317
				</p>
				<p>
					<span class="icon is-pulled-left">
						<i class="fas fa-hashtag is-size-4 is-size-5-mobile"></i>
					</span>
					<span>
						NMLS #1154338. Go here for the FreeRateUpdate
						<a href="http://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1154338" target="_blank">NMLS Consumer Access Page.</a>
					</span>
				</p>
			</div>

			<div class="column">
				<p>
					<a href="http://latimesblogs.latimes.com/money_co/2010/03/mortgage-rates-remain-near-record-lows-for-modern-era.html" rel="nofollow"
					 target="_blank">
						as seen on...
						<br>
						<img src="https://www.freerateupdate.com/images/logo-la-times.png" alt="Los Angeles Times">
					</a>
				</p>
				<p>
					<a href="/contact" target="_blank">Contact Us</a> |
					<a href="/privacy" rel="nofollow" target="_blank">Privacy Policy</a> |
					<a href="/glba" rel="nofollow" target="_blank">GLBA Policy</a> |
					<a href="/cpra_policy" rel="nofollow" target="_blank">CPRA Policy</a>
				</p>
				<p>
					<a href="/terms" rel="nofollow" target="_blank">General Terms</a> |
					<a href="/landing/approved_lenders.php" target="_blank">Approved Lenders</a> |
					<a href="/licensing_disclosure" target="_blank">Licensing Disclosure</a> |
					<a href="/html-sitemap" target="_blank">Sitemap</a>
				</p>
			</div>
		</div>

		<p>
			FreeRateUpdate.com LLC is a Licensed Mortgage Broker, as required by law, with its main office located at 2 Ponds Edge Drive, Chadds Ford, PA 19317. NMLS Unique Identifier #1154338. &copy; FreeRateUpdate.com LLC 2008 - {{ currentYear }}.
			All Rights Reserved. This site is directed at, and made available to, persons in the continental U.S, and Hawaii only.
		</p>
	</div>
</footer>